import { IconContent } from '@icons';

export const alertOctagonFilled: IconContent = {
    md: '<path fill-rule="evenodd" d="M3 8.294 8.294 3h7.412L21 8.294v7.412L15.706 21H8.294L3 15.706V8.294ZM11.25 14V7h1.5v7h-1.5Zm.75 3.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z" />',
};
